module.exports = __webpack_public_path__ + "static/media/Intruded tooth 8.e320a310.png";